import { getInitialState } from './index';
import { State, Booths, Booth } from './types';
import { transformServerBooths } from './utils';

const mutations = {
  setBooths(state: State, booths: Booths) {
    state.booths = booths;
  },
  setIsLoading(state: State, isLoading: boolean) {
    state.isLoading = isLoading;
  },
  deleteBooth(state: State, boothId: string) {
    const booths = { ...state.booths };
    delete booths[boothId];
    state.booths = booths;
  },
  setBooth(state: State, booth: Booth) {
    const transformedBooth: Booths = transformServerBooths([booth]);
    state.booths = {
      ...state.booths,
      [booth.id]: transformedBooth[booth.id]
    };
  },
  reorderBooths(state: State, booths: Booth[]) {
    const reorderBooths: Booth[] = booths.map((booth, index) => {
      return {
        ...booth,
        rank: index
      };
    });
    const transformedBooths = transformServerBooths(reorderBooths);
    state.booths = transformedBooths;
  },
  resetBoothsState(state: State) {
    Object.assign(state, getInitialState());
  }
};

export default mutations;
